<template>
  <div class="">
    <div class="five_step_box mb-20" v-if="true">
      <fiveStep :step="4"></fiveStep>
    </div>
    <div class="exercise_consolidation">
      <div v-if="!$Tools.empty(consolidationList)">
        <el-image class="five_final_step_bg" :src="imgPath('five_final_step_bg.png')"></el-image>
        <div class="p-20 clearance_content">
          <!-- <div class="exercise-title">· 测评通关</div> -->
          <div class="flex FlexBetween Flexalign">
            <div class="exercise-title">· 测评通关</div>
            <div class="flex Flexalign">
              <div class="btn_previous btn_next cursor_pointer" @click="previoustep">
                上一步
              </div>
              <div class="btn_next ml-20 cursor_pointer" @click="nextStep">
                下一步
              </div>
            </div>
          </div>
          <div class="flex Flexalign Flexjustify">
            <el-image class="five_final_step_icon" :src="imgPath('five_final_step_icon.png')"
              v-if="consolidationList.isCorrect == 2"></el-image>
            <el-image class="five_final_step_icon" :src="imgPath('five_final_step_pass_icon.png')"
              v-else-if="consolidationList.isCorrect == 1"></el-image>
            <el-image class="five_final_step_icon" :src="imgPath('five_final_step_error_icon.png')"
              v-else-if="consolidationList.isCorrect == 3"></el-image>
          </div>
          <!-- 新增通关失败场景 -->
          <div class="error_text" v-if="consolidationList.isCorrect == 3 && courseDetail.learningStyle == 2">
            很遗憾，本次通关测试的可用次数已全部用尽</div>
          <div class="error_text" v-if="consolidationList.isCorrect == 3 && courseDetail.learningStyle != 2">
            次通关测试的可用次数已全部用尽，很遗憾您暂未成功通关。需注意，本次考试成绩将纳入本阶段的整体评分。建议您在接下来的阶段更加认真准备，争取更好的结果。</div>
          <div class="btn_answer cursor_pointer" @click="nextStep" v-if="consolidationList.isCorrect == 3 && courseDetail.learningStyle != 2">继续学习</div>
          <div class="btn_answer cursor_pointer" @click="connnectTeacer" v-if="consolidationList.isCorrect == 3 && courseDetail.learningStyle == 2">联系伴学师</div>
          <div class="homework_name" v-if="consolidationList.isCorrect != 3">{{ consolidationList.paperName }}</div>
          <div class="homework_info flex Flexalign Flexjustify mt-15" v-if="consolidationList.isCorrect != 3">
            <div class="flex Flexalign mr-24">
              <el-image class="test_question_num" :src="iconPath('test_question_num.png')"></el-image>
              <div class="ml-5">试题数：{{ consolidationList.questionCount }}题</div>
            </div>
            <div class="flex Flexalign mr-24">
              <el-image class="test_question_num" :src="iconPath('test_total_score.png')"></el-image>
              <div class="ml-5">试卷总分：{{ consolidationList.fullScore }}分</div>
            </div>
            <div class="flex Flexalign">
              <el-image class="test_question_num" :src="iconPath('test_time_icon.png')"></el-image>
              <div class="ml-5">作答时间：{{ consolidationList.answerTime }}分钟</div>
            </div>
          </div>
          <div class="consolidation_info" v-if="consolidationList.isCorrect != 3">
            <div class="flex Flexalign mt-30">
              <div class="consolidation_label">测试描述：</div>
              <div class="consolidation_value">{{ consolidationList.examDetail }}</div>
            </div>
            <div class="flex Flexalign mt-30">
              <div class="consolidation_label">剩余测验测试：</div>
              <div class="consolidation_value">{{ (consolidationList.testCount !=
                -1) ? `${consolidationList.testCount > 0 ? consolidationList.testCount : 0}次` : '不限' }}</div>
            </div>
            <div class="flex Flexalign mt-30">
              <div class="consolidation_label">过关要求：</div>
              <div class="consolidation_value">正确率≥{{ consolidationList.otherRule?.passCondition }}%</div>
            </div>
          </div>
          <div class="btn_answer cursor_pointer" @click="startAnswer"
            v-if="consolidationList.isCorrect != 1 && consolidationList.isCorrect != 2 && (consolidationList.testCount > 0 || consolidationList.testCount == -1)">
            开始作答</div>
          <div class="btn_answer btn_waitRead cursor_pointer" v-if="consolidationList.isCorrect == 2">待批阅</div>
          <div class="answer_record mt-15 cursor_pointer" @click="openRecord"
            v-if="recordList.length && (consolidationList.isCorrect != 1 && consolidationList.isCorrect != 2)">
            作答记录（{{ recordList.length }}）</div>
          <div class="answer_record_list mt-50" v-if="consolidationList.isCorrect == 1">
            <!--  v-if="consolidationList.isCorrect == 1" -->
            <div class="answer_record_one flex">
              <div class="record_num">序号</div>
              <div class="record_time">时间</div>
              <div class="record_spend">用时</div>
              <div class="record_spend">得分</div>
              <div class="record_num record_option">操作</div>
            </div>
            <div class="answer_record_one flex" v-for="(item, index) in recordList" :key="index"
              :class="[index % 2 == 0 ? 'answer_record_one_active' : '']">
              <div class="record_num">{{ index + 1 }}</div>
              <div class="record_time">{{ item.answerTime }}</div>
              <div class="record_spend">{{ $Tools.secondToMinuteFormatNew(item.answerSection) }}</div>
              <div class="record_spend">{{ item.score }}分</div>
              <div class="record_num record_option cursor_pointer text_active" @click="showPaperDetail(item)">详情</div>
            </div>
          </div>
        </div>
      </div>

      <moe-empty url="moe_empty_bg_img.png" emptyText="暂未配置通关测验" v-else></moe-empty>
    </div>

    <answerRecord ref="answerRecord" @showPaperDetail="showPaperDetail"></answerRecord>
  </div>
</template>

<script>
import fiveStep from "./fiveStep.vue";
import answerRecord from '@/components/popup/answerRecord.vue';
import { mapState } from "vuex";
import { debounce } from "@/assets/utils/dbucTrtl";
export default {
  name: "GjkcH5WrongQuestionAnalysis",
  components: {
    fiveStep,
    answerRecord
  },
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      courseRound: (state) => state.learning.courseRound,
    }),
  },
  inject: ['practiceBack', 'updateShowPractice', 'showWrongQuestion'],
  props: {
    courseDetail: {}
  },


  data() {
    return {
      listQuery: {
        chapterId: '',
        schemeId: '',
        roundId: '',
        examScenes: [8],  //  场景8表示通关测评
        phaseId: '',
      },
      consolidationList: {},
      homeworkInfo: {},
      recordList: []
    };
  },

  mounted() {
    this.getMyHomeworkList();
  },

  methods: {
    // 伴学师（个人中心伴学师）
    connnectTeacer(){
      this.href("/personalCenter",{selectMenu:5});
    },
    // 上一步（没有上一章节阶段）
    previoustep() {
      this.$store.commit("learning/setStudyPreviousStep", 5);
    },
    nextStep() {
      this.$store.commit("learning/setStudyStepInfo", 5);
    },
    openRecord() {
      this.$refs.answerRecord.answerRecordShow = true;
      this.$refs.answerRecord.answerRecordList = this.recordList;
    },
    getMyHomeworkList() {
      if (this.$Tools.empty(this.selectLearningInfo)) return
      this.listQuery.chapterId = this.selectLearningInfo?.chapterId;
      this.listQuery.schemeId = this.selectLearningInfo?.schemeId;
      this.listQuery.roundId = this.selectLearningInfo?.roundId;
      this.listQuery.phaseId = this.selectLearningInfo?.id;
      this.$Api.course.getMyHomeworkList(this.listQuery).then(res => {
        if (!this.$Tools.empty(res.data.data)) {
          this.consolidationList = res.data.data[0];
          let paperId = this.consolidationList.paperId;
          let examId = this.consolidationList.examId;
          this.getPaperInfo(paperId);
          this.getExamRecordList(examId);
        }
      }).catch(() => { })
    },
    getPaperInfo(paperId) {
      this.$Api.course.getPaperInfo(paperId).then(res => {
        this.homeworkInfo = res.data.data;
        // let chartsData = [];
        // res.data.data?.difficultyRatio.indicator.forEach((item, index) => {
        //   chartsData.push({ value: res.data.data?.difficultyRatio.value[index], name: item });
        // });
        // this.$refs.difficultProportionPie.initCharts(chartsData);
      }).catch(() => { })
    },
    // 获取答题记录
    getExamRecordList(examId) {
      this.$Api.exam.getExamRecordList(examId).then(res => {
        this.recordList = res.data.data;
      }).catch(() => { })
    },
    startAnswer() {
      this.startTest();
    },
    startTest: debounce(
      function () {
        this.updateShowPractice(true, this.consolidationList.paperId, undefined, 'homework');
      },
      1000,
      false
    ),
    showPaperDetail(info) {
      this.$Api.exam.getExamRecordInfo(info.recordId).then(res => {
        this.showWrongQuestion(true, res.data.data, false, true);
      }).catch(() => { })
    },
  },
};
</script>

<style lang="scss" scoped>
.exercise_consolidation {
  width: 762px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 14px;
  color: #111111;
  position: relative;
  min-height: 400px;

  .five_final_step_bg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 300px;
  }

  .clearance_content {
    position: relative;
    z-index: 9;

    .exercise-title {
      font-size: 18px;
      font-weight: 600;
    }

    .btn_next {
      width: 69px;
      height: 30px;
      line-height: 30px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 18px;
      text-align: center;
      color: #fff;
    }

    .btn_previous {
      background: none;
      border: 1px solid #909090;
      color: #909090;
    }

    .five_final_step_icon {
      width: 200px;
      height: 170px;
      margin-top: -20px;
    }

    .error_text {
      font-size: 14px;
      color: #606060;
      line-height: 28px;
      text-align: center;
      width: 445px;
      margin: 0 auto;
    }

    .homework_name {
      width: 100%;
      text-align: center;
      font-size: 18px;
      color: #111111;
    }

    .homework_info {
      .test_question_num {
        width: 22px;
        height: 22px;
      }
    }

    .consolidation_info {
      font-size: 16px;
      font-weight: 500;

      .consolidation_label {
        width: 150px;
        color: #111111;
      }

      .consolidation_value {
        color: #909090;
        font-weight: normal;
      }
    }

    .btn_answer {
      width: 160px;
      height: 48px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 30px;
      line-height: 48px;
      text-align: center;
      color: #fff;
      margin: 50px auto 0;
    }

    .btn_waitRead {
      background: #FFBD00;
    }

    .answer_record {
      font-size: 14px;
      color: #13d6aa;
      margin: 10px auto;
      text-align: center;
    }

    .answer_record_list {
      .answer_record_one {
        font-size: 14px;
        color: #111111;
        height: 45px;
        line-height: 45px;

        .record_num {
          width: 15%;
          text-align: center;
        }

        .record_time {
          width: 30%;
        }

        .record_spend {
          width: 20%;
        }

        .record_option {
          text-align: start;
        }
      }

      .answer_record_one_active {
        background: #F7F7FA;
      }
    }
  }
}
</style>